var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "content package-student-page package-student-page--assign",
    },
    [
      _c(
        "section",
        {
          ref: "pageHero",
          staticClass: "ps-hero",
          class: { "is-hidden": _vm.isHeroHidden },
        },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "ps-hero__actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "", icon: "el-icon-collection-tag" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.push("/package-student/packages")
                    },
                  },
                },
                [_vm._v("\n            Quản lý gói\n          ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { plain: "", icon: "el-icon-setting" },
                  on: { click: _vm.openAlertConfigDialog },
                },
                [_vm._v("\n            Cấu hình thông báo\n          ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "el-icon-refresh",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.fetchData },
                },
                [_vm._v("\n            Làm mới dữ liệu\n          ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "ps-overview-sticky" }, [
        _c(
          "div",
          {
            ref: "statsGrid",
            staticClass: "ps-stat-grid",
            style: _vm.statsStyle,
          },
          [
            _c("div", { staticClass: "ps-stat-card" }, [
              _vm._m(1),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.totalSchools)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Tổng số trường"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "ps-stat-card ps-stat-card--orange" }, [
              _vm._m(2),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.fullCount)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Đạt / vượt giới hạn"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "ps-stat-card ps-stat-card--red" }, [
              _vm._m(3),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.nearFullCount)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Sắp đầy"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "ps-stat-card ps-stat-card--green" }, [
              _vm._m(4),
              _c("div", [
                _c("span", { staticClass: "ps-stat-card__value" }, [
                  _vm._v(_vm._s(_vm.assignedCount)),
                ]),
                _c("span", { staticClass: "ps-stat-card__label" }, [
                  _vm._v("Đã được áp dụng gói"),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
      _c(
        "section",
        { staticClass: "ps-card ps-card--list", style: _vm.cardLayoutStyle },
        [
          _c("div", { ref: "cardTop", staticClass: "ps-card__top" }, [
            _vm._m(5),
            _c(
              "div",
              { staticClass: "ps-toolbar" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "ps-toolbar__filters",
                    attrs: { inline: "", "label-position": "top" },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Chọn trường" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "250px" },
                            attrs: {
                              size: "small",
                              filterable: "",
                              clearable: "",
                              loading: _vm.schoolOptionsLoading,
                              placeholder: "Chọn trường",
                            },
                            model: {
                              value: _vm.schoolId,
                              callback: function ($$v) {
                                _vm.schoolId = $$v
                              },
                              expression: "schoolId",
                            },
                          },
                          _vm._l(_vm.schoolOptions, function (item) {
                            return _c(
                              "el-option",
                              {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: `${item.id} - ${item.schoolName}`,
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.id))]),
                                _vm._v(" -\n                "),
                                _c("span", [_vm._v(_vm._s(item.schoolName))]),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Trạng thái" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "145px" },
                            attrs: { size: "small" },
                            model: {
                              value: _vm.statusFilter,
                              callback: function ($$v) {
                                _vm.statusFilter = $$v
                              },
                              expression: "statusFilter",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "Tất cả", value: "ALL" },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "Chưa áp dụng",
                                value: "CHUA_GAN",
                              },
                            }),
                            _c("el-option", {
                              attrs: {
                                label: "Còn số lượng",
                                value: "CON_SLOT",
                              },
                            }),
                            _c("el-option", {
                              attrs: { label: "Sắp đầy", value: "SAP_DAY" },
                            }),
                            _c("el-option", {
                              attrs: { label: "Đã đầy", value: "DA_DAY" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Gói đang áp dụng" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "220px" },
                            attrs: {
                              size: "small",
                              filterable: "",
                              clearable: "",
                              placeholder: "Chọn gói",
                            },
                            model: {
                              value: _vm.packageFilter,
                              callback: function ($$v) {
                                _vm.packageFilter = $$v
                              },
                              expression: "packageFilter",
                            },
                          },
                          _vm._l(_vm.packages, function (item) {
                            return _c(
                              "el-option",
                              {
                                key: item.id,
                                attrs: {
                                  value: item.id,
                                  label: `${item.code} - ${item.name}`,
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.code))]),
                                _vm._v(" -\n                "),
                                _c("span", [_vm._v(_vm._s(item.name))]),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "ps-toolbar__actions" },
                  [
                    _c(
                      "el-dropdown",
                      {
                        attrs: { trigger: "click", disabled: _vm.bulkSaving },
                        on: { command: _vm.handleBulkAction },
                        scopedSlots: _vm._u([
                          {
                            key: "dropdown",
                            fn: function () {
                              return [
                                _c(
                                  "el-dropdown-menu",
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "assign",
                                          icon: "el-icon-connection",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Áp dụng gói cho nhiều trường\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              type: "primary",
                              plain: "",
                              loading: _vm.bulkSaving,
                            },
                          },
                          [
                            _vm._v("\n              Tác vụ "),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "ps-card__table" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "schoolTable",
                  staticClass: "sk-table ps-table",
                  attrs: {
                    data: _vm.filteredRows,
                    border: "",
                    stripe: "",
                    "max-height": 760,
                    "empty-text": "Không tìm thấy trường phù hợp",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "STT",
                      type: "index",
                      width: "56",
                      align: "center",
                      fixed: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Mã / Tên trường",
                      "min-width": "340",
                      fixed: "left",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", { staticClass: "ps-school-cell" }, [
                              _c(
                                "div",
                                { staticClass: "ps-school-cell__avatar" },
                                [_c("i", { staticClass: "el-icon-school" })]
                              ),
                              _c(
                                "div",
                                { staticClass: "ps-school-cell__text" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "ps-school-cell__code" },
                                    [_vm._v(_vm._s(row.school.id))]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "ps-school-cell__name" },
                                    [_vm._v(_vm._s(row.school.name))]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Gói đang áp dụng", "min-width": "240" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.package
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "ps-package-code" },
                                    [_vm._v(_vm._s(row.package.code))]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "ps-package-name" },
                                    [_vm._v(_vm._s(row.package.name))]
                                  ),
                                  !row.package.active
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                            effect: "plain",
                                          },
                                        },
                                        [_vm._v("Gói đã ngưng")]
                                      )
                                    : _vm._e(),
                                ]
                              : _c(
                                  "span",
                                  { staticClass: "ps-unassigned-state" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning-outline",
                                    }),
                                    _vm._v(" Chưa áp dụng gói"),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Ngày áp dụng",
                      width: "135",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.assignment
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        row.assignment.assignedAt
                                      )
                                    )
                                  ),
                                ])
                              : _c("span", { staticClass: "ps-row-muted" }, [
                                  _vm._v("—"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số lượng thêm",
                      width: "110",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.assignment
                              ? _c("span", { staticClass: "ps-addon-amount" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(row.addonTotal)
                                    )
                                  ),
                                ])
                              : _c("span", { staticClass: "ps-row-muted" }, [
                                  _vm._v("—"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Giới hạn hiệu lực",
                      width: "165",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.assignment
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "ps-limit-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            row.effectiveLimit
                                          )
                                        ) + " HS"
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "ps-package-cell__base" },
                                    [
                                      _vm._v(
                                        "\n                Gói " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              row.baseLimit
                                            )
                                          ) +
                                          " + SL thêm " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              row.addonTotal
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              : _c("span", { staticClass: "ps-row-muted" }, [
                                  _vm._v("—"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số HS đang học",
                      width: "145",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.assignment
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "ps-limit-value" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            row.currentStudents
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "ps-package-cell__base" },
                                    [
                                      _vm._v(
                                        "/ " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              row.effectiveLimit
                                            )
                                          ) +
                                          " SL học sinh"
                                      ),
                                    ]
                                  ),
                                ]
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        row.currentStudents
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "% sử dụng", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            row.assignment
                              ? _c(
                                  "div",
                                  { staticClass: "ps-usage-cell" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ps-usage-cell__numbers" },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                row.currentStudents
                                              )
                                            ) +
                                              " / " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  row.effectiveLimit
                                                )
                                              )
                                          ),
                                        ]),
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "is-danger":
                                                row.usagePercent >= 100,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatPercent(
                                                  row.usagePercent
                                                )
                                              ) + "%"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("el-progress", {
                                      attrs: {
                                        percentage: Math.min(
                                          row.usagePercent,
                                          100
                                        ),
                                        status: _vm.progressStatus(row),
                                        "show-text": false,
                                        "stroke-width": 7,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", { staticClass: "ps-row-muted" }, [
                                  _vm._v("Chưa có giới hạn"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Trạng thái",
                      width: "145",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.statusType(row),
                                  size: "small",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", { class: _vm.statusIcon(row) }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.statusLabel(row)) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thông báo",
                      width: "135",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: row.notifyEnabled
                                    ? "Tắt thông báo cho trường"
                                    : "Bật thông báo cho trường",
                                  placement: "top",
                                },
                              },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    value: row.notifyEnabled,
                                    disabled: row.notifySaving,
                                    "active-color": "#409eff",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleAlertNotify(row, $event)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ps-notify-state",
                                class: { "is-off": !row.notifyEnabled },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.notifyEnabled
                                        ? "Đang bật"
                                        : "Đang tắt"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Cho phép vượt giới hạn",
                      width: "170",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: row.allowExceedStudentLimit
                                    ? "Tắt quyền cho phép vượt giới hạn"
                                    : "Cho phép thêm học sinh vượt giới hạn gói",
                                  placement: "top",
                                },
                              },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    value: row.allowExceedStudentLimit,
                                    disabled: row.quotaOverrideSaving,
                                    "active-color": "#409eff",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleQuotaOverride(
                                        row,
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ps-notify-state",
                                class: {
                                  "is-off": !row.allowExceedStudentLimit,
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.allowExceedStudentLimit
                                        ? "Đang cho phép"
                                        : "Theo giới hạn gói"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Thao tác",
                      width: "225",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "ps-action-row" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: row.assignment
                                        ? "Đổi gói"
                                        : "Áp dụng gói",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        circle: "",
                                        size: "mini",
                                        icon: "el-icon-connection",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAssignDialog(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Thêm số lượng",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "success",
                                        plain: "",
                                        circle: "",
                                        size: "mini",
                                        icon: "el-icon-plus",
                                        disabled: !row.assignment,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openAddonDialog(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Xem lịch sử thêm số lượng",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "info",
                                        plain: "",
                                        circle: "",
                                        size: "mini",
                                        icon: "el-icon-time",
                                        disabled: !row.assignment,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openHistoryDialog(row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Xem lịch sử sử dụng gói",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "warning",
                                        plain: "",
                                        circle: "",
                                        size: "mini",
                                        icon: "el-icon-document",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPackageHistoryDialog(
                                            row
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ps-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  small: "",
                  background: "",
                  layout: "total, sizes, prev, pager, next",
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  "page-sizes": [10, 20, 50],
                  total: _vm.schoolTotal,
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handlePageSizeChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("AssignPackageDialog", {
        attrs: {
          visible: _vm.assignDialogVisible,
          "school-row": _vm.selectedRow,
          packages: _vm.activePackages,
          saving: _vm.saving,
        },
        on: {
          "update:visible": function ($event) {
            _vm.assignDialogVisible = $event
          },
          submit: _vm.handleAssign,
        },
      }),
      _c("BulkAssignPackageDialog", {
        attrs: {
          visible: _vm.bulkAssignDialogVisible,
          schools: _vm.schoolOptions,
          packages: _vm.activePackages,
          saving: _vm.bulkSaving,
        },
        on: {
          "update:visible": function ($event) {
            _vm.bulkAssignDialogVisible = $event
          },
          submit: _vm.handleBulkAssign,
        },
      }),
      _c("AddonDialog", {
        attrs: {
          visible: _vm.addonDialogVisible,
          "school-row": _vm.selectedRow,
          saving: _vm.saving,
        },
        on: {
          "update:visible": function ($event) {
            _vm.addonDialogVisible = $event
          },
          submit: _vm.handleAddon,
        },
      }),
      _c("AddonHistoryDialog", {
        attrs: {
          visible: _vm.historyDialogVisible,
          "school-row": _vm.selectedRow,
          histories: _vm.histories,
          loading: _vm.historyLoading,
        },
        on: {
          "update:visible": function ($event) {
            _vm.historyDialogVisible = $event
          },
        },
      }),
      _c("PackageUsageHistoryDialog", {
        attrs: {
          visible: _vm.packageHistoryDialogVisible,
          "school-row": _vm.selectedRow,
          histories: _vm.packageHistories,
          loading: _vm.packageHistoryLoading,
        },
        on: {
          "update:visible": function ($event) {
            _vm.packageHistoryDialogVisible = $event
          },
        },
      }),
      _c("PackageLimitAlertTestDialog", {
        attrs: {
          visible: _vm.alertTestDialogVisible,
          "school-row": _vm.selectedRow,
          result: _vm.alertTestResult,
          loading: _vm.alertTestLoading,
        },
        on: {
          "update:visible": function ($event) {
            _vm.alertTestDialogVisible = $event
          },
          send: _vm.handleTestAlert,
        },
      }),
      _c("PackageLimitAlertConfigDialog", {
        attrs: {
          visible: _vm.alertConfigDialogVisible,
          config: _vm.alertConfig,
          loading: _vm.alertConfigLoading,
          saving: _vm.alertConfigSaving,
        },
        on: {
          "update:visible": function ($event) {
            _vm.alertConfigDialogVisible = $event
          },
          submit: _vm.handleSaveAlertConfig,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-hero__main" }, [
      _c("div", { staticClass: "ps-hero__icon" }, [
        _c("i", { staticClass: "el-icon-school" }),
      ]),
      _c("div", [
        _c("h1", [
          _vm._v(
            "Áp dụng gói và theo dõi số lượng học sinh đang học của trường"
          ),
        ]),
        _c("p", [
          _vm._v(
            "Theo dõi mức sử dụng, số lượng học sinh đang học và trạng thái của từng trường trong hệ thống đang sử dụng gói."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-school" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-time" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-stat-card__icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ps-card__heading" }, [
      _c("div", { staticClass: "ps-card__heading-left" }, [
        _c("div", { staticClass: "ps-card__heading-icon" }, [
          _c("i", { staticClass: "el-icon-data-analysis" }),
        ]),
        _c("div", [
          _c("h2", [_vm._v("Danh sách trường")]),
          _c("p", [
            _vm._v(
              "Trạng thái đầy phản ánh mức sử dụng; quyền cho vượt giới hạn là cấu hình riêng của từng trường."
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }